import script from "./base-tooltip.vue?vue&type=script&setup=true&lang=ts"
export * from "./base-tooltip.vue?vue&type=script&setup=true&lang=ts"

import "./base-tooltip.vue?vue&type=style&index=0&id=4f2e5494&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f2e5494"]])

export default __exports__